import { useI18n } from '@cascade/react/i18n';
import { useTickets } from '@cascade/react/tickets';
import { Button, Text } from '@cascade/ui-library';
import classes from './TicketsFailed.module.scss';
import { Page } from '#components/page/index.ts';

export const TicketsFailed = () => {
  const { translate, translateError } = useI18n();
  const { ticketingError, reloadTicketing } = useTickets();

  return (
    <Page iconType='ticket' title={translate('tickets.failed.title')}>
      <div className={classes['tickets-failed']}>
        <Text
          type='body-2'
          role='alert'
          content={translateError(ticketingError)}
        />
        <Button
          label={translate('tickets.failed.retry')}
          onClick={reloadTicketing}
        />
      </div>
    </Page>
  );
};
